import { EventEmitter, Injectable } from "@angular/core";
import { ProductCostApi } from "@planard/@core/backend/api/productCost.api";
import { ProductCostData } from "@planard/@core/entities/interface/productCost";
import { ProductCost } from "@planard/@core/entities/productCost";

@Injectable()
export class ProductCostService extends ProductCostData {
  onPriceReload: EventEmitter<any> = new EventEmitter<any>();

  constructor(private api: ProductCostApi) {
    super();
  }

  listPrices(scenarioId: number, approveRequestId?: number) {
    return this.api.listPrices<any>(scenarioId, approveRequestId);
  }

  update(plan: ProductCost) {
    return this.api.update<any>(plan);
  }
}
